var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 3C26 1.61929 27.1193 0.5 28.5 0.5H59V30.5C59 31.8807 57.8807 33 56.5 33C55.1193 33 54 31.8807 54 30.5V5.5H28.5C27.1193 5.5 26 4.38071 26 3Z",
    fill: "#6978f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7678 2.23223C53.7441 3.20854 53.7441 4.79146 52.7678 5.76777L4.76777 53.7678C3.79146 54.7441 2.20854 54.7441 1.23223 53.7678C0.255922 52.7915 0.255922 51.2085 1.23223 50.2322L49.2322 2.23223C50.2085 1.25592 51.7915 1.25592 52.7678 2.23223Z",
    fill: "#6978f9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7678 6.23223C58.7441 7.20854 58.7441 8.79146 57.7678 9.76777L9.76777 57.7678C8.79146 58.7441 7.20854 58.7441 6.23223 57.7678C5.25592 56.7915 5.25592 55.2085 6.23223 54.2322L54.2322 6.23223C55.2085 5.25592 56.7915 5.25592 57.7678 6.23223Z",
    fill: "#6978f9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.8c000395c6f29f1e1f3cf1cb3fef5c37.svg";
export { ForwardRef as ReactComponent };